export const orgConferencesConstants = {
  LOAD: "OCC_LOAD",
  DELETE: "OCC_DELETE",
};
